import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=3f638926&scoped=true&"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=3f638926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f638926",
  null
  
)

export default component.exports